import { render, staticRenderFns } from "./GeneralPagination.vue?vue&type=template&id=33858204&scoped=true&"
import script from "./GeneralPagination.vue?vue&type=script&lang=js&"
export * from "./GeneralPagination.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPagination.vue?vue&type=style&index=0&id=33858204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33858204",
  null
  
)

export default component.exports